import { ViewRouteTable, TViewRouteTable } from '../transformations/view_route_table';
import { IMicroConfiguration } from '../types/configuration';
import { ViewRouteTree } from '../transformations/view_route_tree';
import { ViewStateProcess } from './view_state';
import { RoutingProcess } from './routing';

import { IUnsafeRouteTree, IRouteTree } from'../../../dip/library/di-hnf/di-hnf.js';
import { View, Process } from'../../../pip/library/pi-interop/pi-interop.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class ViewModelProcess extends Process {
  id = 'view_model';

  configuration: IMicroConfiguration;

  dependencies = ['/routing', '/view_state'];
  processes: {
    view_state: ViewStateProcess;
    routing: RoutingProcess;
  };

  transformations: {
    routeTable: ViewRouteTable;
    routeTree: ViewRouteTree;
  };

  models: {
    preloadedViews: Record<string, View>;
    routeTable: TViewRouteTable;
    routeTree: IRouteTree;
  };

  initialize(configuration: IMicroConfiguration) {
    this.configuration = configuration;
    this.models = {
      preloadedViews: {},
      routeTable: {},
      routeTree: {} as IRouteTree
    };

    this.transformations = {
      routeTable: new ViewRouteTable(),
      routeTree: new ViewRouteTree()
    };

    return f1.done(this);
  }

  activate() {
    if (this.configuration.routes) {
      this.includeRoutes(this.configuration.routes);
    }

    return f1.done(this);
  }

  includeRoutes(view_stateTree: IUnsafeRouteTree) {
    const routeTree = this.transformations.routeTree.read(view_stateTree);
    const routeTable = this.transformations.routeTable.read(routeTree);

    this.models.routeTree = routeTree;
    this.models.routeTable = routeTable;

    this.processes.routing.addRouteTable(this.models.routeTable);
  }
}
